import React from 'react';
import { useParams } from 'react-router-dom';
import SurveyAnalytics from '../components/SurveyAnalytics';

function SurveyAnalyticsPage() {
  const { id } = useParams();

  return (
    <main className="survey-analytics-page">
      <h1>Survey Analytics</h1>
      <SurveyAnalytics surveyId={id} />
    </main>
  );
}

export default SurveyAnalyticsPage; 